import styled from 'styled-components';

const VerticalCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  height: 100vh;
`;

export default VerticalCenter;
